import React from 'react';
type LabelProps = {
  children: React.ReactNode;
  tone?: 'copper' | 'navy' | 'cream';
  className?: string;
};
const tones = {
  copper: 'text-copper',
  navy: 'text-navy/55',
  cream: 'text-cream/55'
};
export function Label({
  children,
  tone = 'copper',
  className = ''
}: LabelProps) {
  return <span className={`font-sans text-[10px] sm:text-[11px] font-medium uppercase tracking-label ${tones[tone]} ${className}`} data-id="element-116" data-mp="3614m0momgzho">
      {children}
    </span>;
}